<template>
  <div class="collage">
    <div class="collage__col collage__col--left">
      <StoryblokComponent
        v-for="childBlok in blok.left_column"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
    <div class="collage__right">
      <div class="collage__col">
        <StoryblokComponent
          v-for="childBlok in blok.right_column"
          :key="childBlok._uid"
          :blok="childBlok"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { SbCollage } from '@/types'

interface Props {
  blok: SbCollage
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.collage {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 22px;

  @media (min-width: $breakpoint-md) {
    grid-template-columns: 1fr 1fr;
  }

  &__col {
    display: grid;
    column-gap: 16px;
    row-gap: 16px;
    align-items: flex-end;
    justify-content: center;
    grid-template-columns: repeat(6, 1fr);

    &--left {
      display: none;

      @media (min-width: $breakpoint-md) {
        display: grid;
        column-gap: 22px;
        row-gap: 22px;
      }
    }
  }
}
</style>
